import { addDays } from 'date-fns';

import {
    AgentWorkloadFeedbackReminderConfigurator,
    AgentWorkloadReminder,
    AgentWorkloadReminderType,
    CollectCapacityReminderContext,
} from '../CollectCapacityReminderConfigurator';
import { getWorkloadNeverConfiguredSince } from '../../../utils';

export class NoFeedbackForTwoWeeksConfigurator
    implements AgentWorkloadFeedbackReminderConfigurator
{
    support(): boolean {
        return true;
    }

    get(context: CollectCapacityReminderContext): AgentWorkloadReminder | null {
        if (!context.agentWorkload) {
            return null;
        }

        const neverConfiguredSince = getWorkloadNeverConfiguredSince();

        let remindAt = addDays(context.agentWorkload.lastUpdatedAt, 14);

        if (neverConfiguredSince) {
            remindAt = addDays(neverConfiguredSince, 14);
        }

        return {
            type: AgentWorkloadReminderType.NoFeedbackForTwoWeeks,
            remindAt: remindAt,
        };
    }
}
